import AsyncSelect from 'react-select/async';
import './matter-split-input.scss';

const MatterSplitInput = ({
  data,
  matterSplits,
  singleMatter,
  loadMatters,
  onSingleMatterChange,
  onSplitsChange,
  matterError,
  matterTouched,
  onMatterBlur,
}) => {
  const isMultiple = Array.isArray(matterSplits);

  const handleSwitchToMultiple = () => {
    if (!isMultiple) {
      onSplitsChange([
        { matter: singleMatter ?? null, percentage: 50 },
        { matter: null, percentage: 50 },
      ]);
    }
  };

  const handleSwitchToSingle = () => {
    if (isMultiple) {
      const firstMatter = matterSplits[0]?.matter ?? null;
      if (firstMatter) {
        onSingleMatterChange(firstMatter);
      }
      onSplitsChange(null);
    }
  };

  const handleSplitMatterChange = (index, choice) => {
    const updated = matterSplits.map((s, i) => (i === index ? { ...s, matter: choice } : s));
    onSplitsChange(updated);
  };

  const handleSplitPercentageChange = (index, value) => {
    const parsed = parseInt(value, 10);
    const updated = matterSplits.map((s, i) =>
      i === index ? { ...s, percentage: isNaN(parsed) ? '' : parsed } : s
    );
    onSplitsChange(updated);
  };

  const handleAddRow = () => {
    onSplitsChange([...matterSplits, { matter: null, percentage: 0 }]);
  };

  const handleRemoveRow = (index) => {
    onSplitsChange(matterSplits.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div className='matter-split-tabs'>
        <button
          type='button'
          role='tab'
          aria-selected={!isMultiple}
          className={`matter-split-tab${!isMultiple ? ' active' : ''}`}
          onClick={handleSwitchToSingle}
        >
          {data.t.read('review_expense.matter.single_matter')}
        </button>
        <button
          type='button'
          role='tab'
          aria-selected={isMultiple}
          className={`matter-split-tab${isMultiple ? ' active' : ''}`}
          onClick={handleSwitchToMultiple}
        >
          {data.t.read('review_expense.matter.multiple_matter')}
        </button>
      </div>

      {!isMultiple && (
        <>
          <AsyncSelect
            cacheOptions
            loadOptions={loadMatters}
            onChange={onSingleMatterChange}
            value={singleMatter}
            placeholder={data.t.read('review_expense.matter.placeholder')}
            noOptionsMessage={() => data.t.read('review_expense.matter.type_to_search')}
            isClearable
            onBlur={onMatterBlur}
            styles={matterTouched && matterError ? { control: (base) => ({ ...base, borderColor: '#dc3545' }) } : undefined}
          />
          {matterTouched && matterError && (
            <div className='text-danger small mt-1'>{matterError}</div>
          )}
        </>
      )}

      {isMultiple && (
        <div>
          {matterSplits.map((split, index) => (
            <div key={index} className='matter-split-row'>
              <div className='matter-split-select'>
                <AsyncSelect
                  cacheOptions
                  loadOptions={loadMatters}
                  onChange={(choice) => handleSplitMatterChange(index, choice)}
                  value={split.matter}
                  placeholder={data.t.read('review_expense.matter.placeholder')}
                  noOptionsMessage={() => data.t.read('review_expense.matter.type_to_search')}
                  isClearable
                />
              </div>
              <div className='input-group matter-split-percentage'>
                <input
                  type='number'
                  className='form-control'
                  value={split.percentage}
                  min={1}
                  max={100}
                  step={1}
                  onChange={(e) => handleSplitPercentageChange(index, e.target.value)}
                  aria-label={data.t.read('review_expense.matter.percentage_label')}
                />
                <div className='input-group-append'>
                  <span className='input-group-text'>%</span>
                </div>
              </div>
              {matterSplits.length > 2 && (
                <button
                  type='button'
                  className='matter-split-remove'
                  aria-label={data.t.read('review_expense.matter.remove_matter')}
                  onClick={() => handleRemoveRow(index)}
                >
                  &times;
                </button>
              )}
            </div>
          ))}
          <button type='button' className='matter-split-add' onClick={handleAddRow}>
            {data.t.read('review_expense.matter.add_matter')}
          </button>
        </div>
      )}
    </div>
  );
};

export default MatterSplitInput;
